export default __webpack_public_path__ + "0d681036926039c34f1be51300fc0c5d.png";